import londonP1Image from "../../assets/blog/london-p1-womens-padel.webp";

export const calvoFernandezLondonP1Upset = {
  id: 8,
  slug: "calvo-fernandez-london-p1-upset",
  title: "Calvo and Fernandez stun the world No. 1 pair at London P1",
  excerpt:
    "Martina Calvo and Claudia Fernandez beat Gemma Triay and Delfi Brea in straight sets. Here is why the result mattered, and what club players can take from it.",
  seoTitle: "Calvo & Fernandez Win London P1 | Racketly",
  date: "2026-08-14",
  category: "Padel news",
  image: londonP1Image,
  imageWidth: 1200,
  imageHeight: 1800,
  imageAlt: "A woman holding a padel racket beside the net on an indoor court",
  imagePosition: "center 38%",
  imageCaption: "Illustrative padel photo. The player shown is not one of the professionals named in this article.",
  imageCredit: "Anhelina Vasylyk on Pexels",
  imageCreditUrl: "https://www.pexels.com/photo/woman-playing-padel-tennis-indoors-35248487/",
  imageLicense: "Pexels License",
  imageLicenseUrl: "https://www.pexels.com/license/",
  content: `
  <p class="mb-4">Martina Calvo and Claudia Fernandez arrived at the London Premier Padel P1 with almost no shared history. They left with the trophy.</p>

  <p class="mb-4">The new pair beat world No. 1 duo Gemma Triay and Delfi Brea 7-5, 6-3 in the final on 9 August. This was only Calvo and Fernandez's second tournament together. Calvo, 18, also became the youngest player to win a Premier Padel title.</p>

  <p class="mb-4">That combination makes the result hard to dismiss as an ordinary upset. Triay and Brea had won in Pretoria the previous week and came into London as the pair everyone else had to solve.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">The first set did the damage</h2>
  <p class="mb-4">The opening set stayed close until its final games. Fernandez and Calvo handled those points better and took it 7-5. In the second set they moved quickly to a 5-0 lead. Triay and Brea recovered two games, but the gap was already too large.</p>

  <p class="mb-4">The score tells a useful story. The younger pair did not need to dominate every stretch of the match. They won the late points in a tight first set, then used that confidence to build an early cushion in the second.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">A partnership that worked immediately</h2>
  <p class="mb-4">New pairings often need time to settle who takes the middle, who changes direction first, and how both players react when a rally becomes messy. Calvo and Fernandez looked unusually clear on those decisions in London.</p>

  <p class="mb-4">Their week also showed why age is a poor shortcut for judging tactical maturity. Calvo did not play like someone waiting for permission to attack. Fernandez gave the pair enough stability to choose those moments without forcing them.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">What club players can borrow</h2>
  <p class="mb-4">The obvious lesson is not to copy a professional shot. It is to agree on a few simple decisions before the match starts. Who owns the lob through the middle? Who calls the switch? Where will the first serve return go when the score gets tight?</p>

  <p class="mb-4">Those small agreements remove hesitation. They matter even more in a new partnership, when neither player can rely on months of instinctive movement together.</p>

  <p class="mb-4">London gave Calvo and Fernandez a record and a trophy. The more interesting part was how quickly they looked like a real team.</p>

  <p class="mt-8 text-sm"><strong>Sources:</strong> <a href="https://cadenaser.com/baleares/2026/08/10/triay-i-brea-es-queden-sense-titol-a-londres-despres-de-caure-davant-fernandez-i-calvo-radio-menorca/" target="_blank" rel="noopener noreferrer">Cadena SER match report</a> and <a href="https://www.padelfip.com/events/london-p1-2026/" target="_blank" rel="noopener noreferrer">FIP London P1 tournament information</a>.</p>
`,
};
